<cxone-modal id="add-feed-modal" [headerTitle]="headerTitle" [allowClose]="true" [modalSize]="'m'"
    [focusOnShow]="true" [customFooter]="true" (dismissed)="cancel()" #modalDialog>

    <cxone-modal-body class="cx-one-ui" id="modal-content" [style.height]="advancedVisibility ? '320px' : '334.69px'">
        <div class="advanced-link" *ngIf="advancedVisibility">
            <span class="text-link" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Advanced" 
             (click)="advance()">
                Advanced
            </span>
        </div>
        <cxone-omnibar id="omnibar-container" [itemCountLabel]="feedCountLabel" [isFilterable]="false"
            [searchPlaceholderText]="searchPlaceholderText" (searchQueryChange)="userSearchQueryChange($event)"
            [searchQuery]="searchInput">
        </cxone-omnibar>
        <cxone-grid [gridOptions]="gridOptions" *ngIf="gridOptions && gridOptions.hasOwnProperty('columnDefs')" id="ETL-grid">
        </cxone-grid>

    </cxone-modal-body>
    <cxone-modal-footer>
        <div class="cx-one-ui" id="add-simple-feed-dialog-footer">
            <button cvLocalizedText langSection="ETL_Reporting_Set" langKey="Cancel" (click)="cancel()"
                id="cancel-button" class="cxone-btn btn-md btn-secondary btn-bg-is-white" tabindex="0">
                Cancel
            </button>

            <button cvLocalizedText langSection="ETL_Reporting_Set" langKey="Save" (click)="save()" id="submit-button"
                class="cxone-btn btn-md btn-primary" tabindex="0" [disabled]="saveDisabled">
                Save
            </button>
        </div>
    </cxone-modal-footer>
</cxone-modal>